import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { map } from 'ramda';
import Banner from '../banner/Banner.jsx';
import Button from '../button/Button.jsx';
import TextFieldEditor from '../text-field-editor/TextFieldEditor.jsx';
import TextAreaEditor from '../text-area-editor/TextAreaEditor.jsx';
import Spacer from '../spacer/Spacer.jsx';
import Tooltip, { RIGHT, INFO } from '../tooltip/Tooltip.jsx';

import s from './FormModal.module.scss';

/*
 * Render several text fields for the Form
 * Determined by the textOptions field in the options prop for Form
 */
const TextFields = ({ editableValues, handleChange, options, invalid }) => {
    const createTextField = textFieldOptions => {
        const Editor = textFieldOptions.area ? TextAreaEditor : TextFieldEditor;
        return (
            <React.Fragment key={textFieldOptions.label}>
                <Editor
                    big
                    label={textFieldOptions.label}
                    value={editableValues[textFieldOptions.value]}
                    onChange={value => handleChange({ [textFieldOptions.value]: value })}
                    password={textFieldOptions.password}
                    invalid={invalid}
                />
                <Spacer height={24} />
            </React.Fragment>
        );
    };

    return map(createTextField, options);
};

TextFields.propTypes = {
    editableValues: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
};

const Form = ({ options, banner, handleChange, editableValues }) => (
    <div className={s.form}>
        <div className={s.title}>{options.title}</div>
        <button type="button" onClick={options.handleClose} className={classNames('icon-close', s.closeIcon)}>
            <Tooltip arrowPosition={RIGHT} type={INFO} text="Close" form />
        </button>
        <Banner banner={banner} className={classNames(s.formBanner, { [s.notVisible]: !banner.isVisible })} />
        <TextFields editableValues={editableValues} handleChange={handleChange} options={options.textOptions} invalid={banner.color === 'red'} />
        <Button label={options.buttonText} onClick={options.handleSubmit} color="blue" className={s.formButton} />
    </div>
);

Form.propTypes = {
    banner: PropTypes.shape({ message: PropTypes.string, color: PropTypes.string, icon: PropTypes.string }).isRequired,
    editableValues: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    options: PropTypes.object.isRequired,
};

export default Form;
